<template>
  <section id="userIndex">
    <DeleteDialog
      v-if="deleteDialog"
      mode="test"
      :dialogProp="deleteDialog"
      @dialog:close="closeDialog"
      :item="itemToDelete"
    />
    <v-scroll-y-transition hide-on-leave>
      <TestForm
        v-if="formDialog"
        :dialogProp="formDialog"
        @processFormDialog:close="closeDialog"
        :dataToForm="dataToForm"
        :mode="formMode"
      />
    </v-scroll-y-transition>
    <v-scroll-y-transition hide-on-leave>
      <v-container fluid v-if="!formDialog">
        <v-row class="justify-between align-center mb-5">
          <v-col cols="12" md="auto">
            <v-btn
              class="accent shadow-4 px-8"
              large
              rounded
              @click.stop="openRegisterForm()"
              >Realizar Prueba</v-btn
            >
          </v-col>

          <v-col cols="12" md="auto" class="ml-auto">
            <v-text-field
              filled
              rounded
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="!isLoading" align="center" class="mb-5">
          <v-divider></v-divider>
          <p class="primary--text font-weight-bold mb-0 mx-3 text-body-2">
            Ultimas creadas
          </p>
          <v-divider></v-divider>
        </v-row>
        <v-row>
          <v-card class="shadow-1 mb-5" min-width="100%">
            <v-skeleton-loader
              v-if="isLoading"
              type="table"
              class="pa-5"
              style="background: white"
            >
              <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
            </v-skeleton-loader>
            <v-data-table
              v-else
              :headers="headers"
              :items="testList"
              :search="search"
              :items-per-page="10"
              hide-default-footer
              :page.sync="page"
            >
              <template v-slot:[`item.evaluation.name`]="{ item }">
                <v-list
                  two-line
                  max-width="350px"
                  class="transparent my-0 py-0"
                >
                  <v-list-item class="px-0">
                    <v-list-item-content class="d-block d-md-none mr-2">
                      <v-list-item-title
                        class="primary--text text--darken-1 font-weight-medium"
                      >
                        {{ item.evaluation.name }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-content class="d-none d-md-block ml-3">
                      <v-list-item-title
                        class="text--darken-1 font-weight-medium"
                      >
                        {{ item.evaluation.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:[`item.user.name`]="{ item }">
                <v-list
                  two-line
                  max-width="350px"
                  class="transparent my-0 py-0"
                >
                  <v-list-item class="px-0">
                    <v-list-item-content class="d-block d-md-none mr-2">
                      <v-list-item-title
                        class="primary--text text--darken-1 font-weight-medium"
                      >
                        {{ item.user.name }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-content class="d-none d-md-block ml-3">
                      <v-list-item-title
                        class="text--darken-1 font-weight-medium"
                      >
                        {{ item.user.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                <v-list
                  two-line
                  max-width="350px"
                  class="transparent my-0 py-0"
                >
                  <v-list-item class="px-0">
                    <v-list-item-content class="d-block d-md-none mr-2">
                      <v-list-item-title
                        class="primary--text text--darken-1 font-weight-medium"
                      >
                        {{ normalizeDate(item.created_at) }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-content class="d-none d-md-block ml-3">
                      <v-list-item-title
                        class="text--darken-1 font-weight-medium"
                      >
                        {{ normalizeDate(item.created_at) }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:[`item.observations`]="{ item }">
                <v-list
                  two-line
                  max-width="350px"
                  class="transparent my-0 py-0"
                >
                  <v-list-item class="px-0">
                    <v-list-item-content class="d-block d-md-none mr-2">
                      <v-list-item-title
                        class="primary--text text--darken-1 font-weight-medium"
                        v-html="item.observations"
                      ></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-content class="d-none d-md-block ml-3">
                      <v-list-item-title
                        class="text--darken-1 font-weight-medium"
                        v-html="item.observations"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
              <!-- <template v-slot:[`item.questions`]="{ item }">
          <v-list-item-content class="d-none d-md-block ml-3">
            <v-btn
              @click="toggleResultDialog(item)"
              class="accent shadow-4 px-8"
              rounded
              >Ver</v-btn
            >
          </v-list-item-content>
        </template> -->
              <template v-slot:[`item.action`]="{ item }">
                <v-hover v-slot:default="{ hover }">
                  <v-btn
                    text
                    icon
                    :color="hover ? 'accent' : 'blue-grey'"
                    @click.stop="toggleResultDialog(item)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </v-hover>
                <v-hover v-slot:default="{ hover }">
                  <v-btn
                    text
                    icon
                    :color="hover ? 'accent' : 'blue-grey'"
                    @click.stop="editTest(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </v-hover>

                <v-hover v-slot:default="{ hover }">
                  <v-btn
                    text
                    icon
                    :color="hover ? 'error' : 'blue-grey'"
                    @click.stop="deleteTest(item)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-hover>
              </template>
            </v-data-table>
          </v-card>
        </v-row>
      </v-container>
    </v-scroll-y-transition>

    <!-- Results -->
    <v-dialog
      v-model="resultsDialog"
      v-if="resultsDialog"
      scrollable
      max-width="700"
    >
      <v-card>
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
          rounded
          height="6"
        ></v-progress-linear>
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Resumen
            </v-card-title>
          </v-img>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-row justify="center">
                <v-col cols="12">
                  <h5 class="primary--text font-weight-medium ma-0">
                    Detalles
                  </h5>
                </v-col>
                <v-col cols="10" class="pa-0">
                  <p class="ma-0">Agente: {{ itemToResults.user.name }}</p>
                </v-col>
                <v-col cols="10" class="pa-0">
                  <p class="ma-0">Fecha: {{ itemToResults.date }}</p>
                </v-col>
                <v-col cols="10" class="pa-0">
                  <p class="ma-0">
                    Observaciones:
                    {{ itemToResults.observations || "" }}
                  </p>
                </v-col>
                <!-- <v-col cols="10" class="pa-0">
                  <p class="primary--text ma-0">
                    {{ `Grabacion: ${itemToResults.recordings}` }}
                  </p>
                </v-col> -->
                <v-col cols="12">
                  <h5 class="primary--text font-weight-medium ma-0">
                    Respuestas
                  </h5>
                </v-col>
              </v-row>
              <v-row
                v-for="res in itemToResults.test_response"
                justify="center"
                :key="res.id"
              >
                <v-col cols="10" class="pa-0">
                  <v-card-text class="pa-0">
                    <h5 class="ma-0">
                      {{ res.question.name }}
                    </h5>
                  </v-card-text>
                </v-col>
                <v-col cols="12"> <v-spacer></v-spacer></v-col>
                <v-col cols="10" class="pa-0">
                  <v-card-text class="pa-0">
                    <h6 class="ma-0">
                      {{ res.answer.name }} - Valor:
                      {{ res.answer.value }}
                    </h6>
                  </v-card-text>
                </v-col>
                <v-col cols="12"> <v-spacer></v-spacer></v-col>
                <v-col cols="10" class="pa-0">
                  <v-card-text class="pa-0">
                    <h5 class="ma-0">Observaciones:</h5>
                  </v-card-text>
                </v-col>
                <v-col cols="12"> <v-spacer></v-spacer></v-col>
                <v-col cols="10" class="pa-0">
                  <v-card-text class="pa-0">
                    <h6 class="ma-0">
                      {{ res.observation || "Sin observaciones" }}
                    </h6>
                  </v-card-text>
                </v-col>
                <v-col cols="10">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import axios from "axios";
import moment from "moment";
import TestForm from "@/components/Tests/TestForm";
import DeleteDialog from "@/components/Utils/DeleteDialog";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: {
    TestForm,
    DeleteDialog,
  },
  data() {
    return {
      headers: [
        {
          sortable: true,
          text: "Evaluacion",
          align: "left",
          value: "evaluation.name",
          class: "primary--text",
          width: "15%",
        },
        {
          sortable: true,
          text: "Usuario",
          align: "left",
          value: "user.name",
          class: "primary--text",
          width: "20%",
        },
        {
          sortable: true,
          text: "Fecha",
          align: "left",
          value: "date",
          class: "primary--text",
          width: "15%",
        },
        {
          sortable: false,
          text: "Observaciones",
          align: "left",
          value: "observations",
          class: "primary--text",
          width: "20%",
        },
        // {
        //   text: "Resultados",
        //   align: "left",
        //   sortable: false,
        //   value: "questions",
        //   class: "primary--text",
        //   width: "10%",
        // },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
      totalItems: 0,
      search: "",
      data: [],
      Users: [],
      loading: true,
      itemToResults: {},
      testList: [],
      // Form
      formDialog: false,
      formMode: "register",
      dataToForm: null,

      //Delete Dialog
      deleteDialog: false,
      itemToDelete: null,

      //Dialog
      dialog: false,
      resultsDialog: false,

      isLoading: true,
    };
  },
  created() {
    this.getTests();
    this.getUsers();
  },

  computed: {
    Evaluations() {
      return this.$store.getters["evaluations/GET_ALL_EVALUATIONS"];
    },
  },

  methods: {
    openRegisterForm() {
      this.formDialog = true;
      this.formMode = "register";
    },
    closeDialog(reloadList = false) {
      this.formDialog = false;
      this.deleteDialog = false;
      this.itemToDelete = false;
      this.dataToForm = null;
      if (reloadList) this.getTests();
    },
    editTest(item) {
      this.formDialog = true;
      this.formMode = "edit";
      this.dataToForm = item;
    },
    deleteTest(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    async getUsers() {
      const accessToken = localStorage.getItem("token");
      const res = await axios.get(
        `${process.env.VUE_APP_ROOTAPI}/quality/test_user`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      this.Users = res.data.data;
    },

    toggleResultDialog(item) {
      this.itemToResults = item;
      this.resultsDialog = !this.resultsDialog;
    },
    //Store
    async getTests() {
      this.isLoading = true;
      try {
        const { data: firstData } = await PbxHttpClient.get(`/quality/test`);
        this.testList = firstData.data.reverse();
        if (firstData.last_page !== 1) {
          const { data } = await PbxHttpClient.get(`/quality/test`, {
            params: { page: firstData.last_page },
          });
          this.testList = data.data.reverse();
        }
      } catch (err) {
        console.log("error getting tests", err);
      }
      this.isLoading = false;
    },
    async getEvaluations() {
      await this.$store.dispatch("evaluations/SHOW_EVALUATIONS");
    },
    normalizeDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
